export const PreviewWidth = 272;

export enum Direction {
  FORWARD = 'forward',
  BACKWARD = 'backward',
}

export const AnimationsMap = {
  [Direction.FORWARD]: {
    enter: 'moveFromRight',
    leave: 'moveToLeft',
  },
  [Direction.BACKWARD]: {
    enter: 'moveFromLeft',
    leave: 'moveToRight',
  },
};

export enum DataTestAttrs {
  PREV = 'Show previous preview',
  NEXT = 'Show next preview',
  CLOSE = 'Close preview',
}
